module.exports = __webpack_public_path__ + "static/media/benemite.b03afa96.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/acaro_cristalino_aguacate/preventiva/benemite.png
// module id = 1082
// module chunks = 3